$(document).ready(function () {
    'use strict'

    $('.js_showFranchiseListBtn').on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('open').next('ul').slideFadeToggle();
    });
});